/**
 * BCC France — Event CPT Tab Navigation
 *
 * Manages tab switching between event sections (Infos, Programme, Lieu, etc.)
 * Works on both desktop and mobile with horizontal scrolling tabs.
 * Supports navigation via URL hash (e.g., #event-programme).
 *
 * @package bccfrance
 */

function activateTab( targetTabId ) {
	const tabs = document.querySelectorAll( '.event-tab' );
	const sections = document.querySelectorAll( '.event-section' );

	if ( ! targetTabId ) {
		return;
	}

	// Find the corresponding tab
	const targetTab = document.querySelector( `[data-tab="${ targetTabId }"]` );
	if ( ! targetTab ) {
		return;
	}

	// Remove active state from all tabs
	tabs.forEach( ( t ) => {
		t.classList.remove( 'is-active' );
	} );

	// Add active state to clicked tab
	targetTab.classList.add( 'is-active' );

	// If clicking Infos (event-main), show (active) all sections
	if ( targetTabId === 'event-main' ) {
		sections.forEach( ( section ) => {
			section.classList.add( 'is-active' );
		} );
	} else {
		// Hide all sections, then show only the target
		sections.forEach( ( section ) => {
			section.classList.remove( 'is-active' );
		} );

		const targetSection = document.getElementById( targetTabId );
		if ( targetSection ) {
			targetSection.classList.add( 'is-active' );
		}
	}

	// Scroll tab into view on mobile
	// setTimeout( () => {
	// 	targetTab.scrollIntoView( { behavior: 'smooth', block: 'nearest', inline: 'center' } );
	// }, 100 );

	// Scroll section into view with 100px offset
	const targetSection = document.getElementById( targetTabId );
	if ( targetSection ) {
		setTimeout( () => {
			const elementPosition = targetSection.getBoundingClientRect().top + window.scrollY - 200;
			window.scrollTo({
				top: elementPosition,
				behavior: 'smooth'
			});
		}, 50 );
	}
}

export function initEventTabs() {
	const tabs = document.querySelectorAll( '.event-tab' );
	const sections = document.querySelectorAll( '.event-section' );

	if ( ! tabs.length || ! sections.length ) {
		return;
	}

	// By default, show all sections (keep them all visible)
	sections.forEach( ( section ) => {
		section.classList.add( 'is-active' );
	} );

	// Check for hash in URL on page load
	const initialHash = window.location.hash.slice( 1 );
	if ( initialHash && initialHash.startsWith( 'event-' ) ) {
		activateTab( initialHash );
	}

	// Tab click handler
	tabs.forEach( ( tab ) => {
		tab.addEventListener( 'click', ( e ) => {
			e.preventDefault();
			e.stopPropagation();

			const targetTabId = tab.dataset.tab;

			if ( ! targetTabId ) {
				return;
			}

			// Update URL hash
			window.location.hash = targetTabId;

			// Activate tab
			activateTab( targetTabId );
		} );
	} );

	// Listen for hash changes (e.g., browser back/forward)
	window.addEventListener( 'hashchange', () => {
		const newHash = window.location.hash.slice( 1 );
		if ( newHash && newHash.startsWith( 'event-' ) ) {
			activateTab( newHash );
		}
	} );
}
